import { api } from './api';

export interface DashboardQuery {
  prompt: string;
  chartType?: string;
  filters?: any;
}

export interface ChartConfig {
  type: 'bar' | 'line' | 'pie' | 'doughnut' | 'area' | 'scatter' | 'heatmap' | 'radar' | 'bubble' | 'treemap' | 'streamgraph' | 'horizon' | 'connected-scatter' | 'dot-plot' | 'slope-chart';
  title: string;
  data: any[];
  xAxis?: string;
  yAxis?: string;
  groupBy?: string;
  aggregation?: 'count' | 'sum' | 'avg' | 'min' | 'max';
  timeRange?: string;
  filters?: any;
  query?: string;
  description?: string;
  insights?: string[];
  colorScheme?: 'modern' | 'professional' | 'vibrant' | 'gradient';
  interactive?: boolean;
  animated?: boolean;
  showLegend?: boolean;
  showGrid?: boolean;
  orientation?: 'horizontal' | 'vertical';
}

export interface AIDashboardResponse {
  success: boolean;
  data: {
    prompt: string;
    charts: ChartConfig[];
    generatedAt: string;
  };
}

export interface SuggestedPromptsResponse {
  success: boolean;
  data: {
    category: string;
    prompts: string[];
  }[];
}

export const aiDashboardApi = {
  generateDashboard: async (query: DashboardQuery): Promise<AIDashboardResponse> => {
    const response = await api.post('/ai-dashboard/generate', query);
    return response.data;
  },

  getSuggestedPrompts: async (): Promise<SuggestedPromptsResponse> => {
    const response = await api.get('/ai-dashboard/prompts');
    return response.data;
  },

  getAvailableMetrics: async () => {
    const response = await api.get('/ai-dashboard/metrics');
    return response.data;
  }
};